module.exports = __webpack_public_path__ + "img/teeth-14.358b0e99.png";